import { cn } from "@/lib/utils.ts";
import Lottie from "lottie-react";
import loaderAnimation from "./loader-lottie.json";

type LoaderSize = "default" | "sm" | "xs";

const sizeStyles = {
  default: "size-12",
  sm: "size-6",
  xs: "size-4",
} satisfies Record<LoaderSize, string>;

export const Loader = ({
  size = "default",
  className,
}: {
  size?: LoaderSize;
  className?: string;
}) => {
  // In native WebView, the native skeleton handles loading state
  if (window.isWebView) return null;

  return (
    <div data-testid="loader" className={cn("flex items-center justify-center h-full", className)}>
      <Lottie animationData={loaderAnimation} className={sizeStyles[size]} loop={true} />
    </div>
  );
};
